import { render } from "./EventRequestView.vue?vue&type=template&id=28369020&scoped=true"
import script from "./EventRequestView.vue?vue&type=script&lang=js"
export * from "./EventRequestView.vue?vue&type=script&lang=js"

import "./EventRequestView.vue?vue&type=style&index=0&id=28369020&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28369020"]])

export default __exports__